/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

import Device, {
  config,
  constants,
  DeviceUrlInterceptor,
  FeatureCollection,
  FeatureModel,
  FeaturesModel,
} from '@webex/internal-plugin-device';

export default Device;
export {config, constants, DeviceUrlInterceptor, FeatureCollection, FeatureModel, FeaturesModel};
